import { Action } from '../actions';
import {
    BASE_USER_SETTINGS_SUBMITTED,
    CHANGE_WELCOME_PAGE_DATA,
    SUBMIT_BASE_USER_SETTINGS
} from '../actions/welcome-screen';
import { ReducerCustom } from '../service/Redux/Redux';
import { WelcomeState } from '../typings/state';
import { WelcomePageState } from '../typings/welcome';

export interface WelcomeInitializationData {
    baseSettings: {
        country: string;
        currency: string;
    };
}

export function getWelcome(
    data?: WelcomeInitializationData
): ReducerCustom<WelcomeState> {
    const welcomeInitialState: WelcomeState = {
        isLoading: false,
        baseSettings: data ? data.baseSettings : {},
        pageState: WelcomePageState.CountryAndCurrency
    };

    return function welcome(
        state: WelcomeState = welcomeInitialState,
        action: Action
    ): WelcomeState {
        switch (action.type) {
            case SUBMIT_BASE_USER_SETTINGS:
                return {
                    ...state,
                    isLoading: true
                };
            case CHANGE_WELCOME_PAGE_DATA:
                return {
                    ...state,
                    baseSettings: { ...state.baseSettings, ...action.value }
                };
            case BASE_USER_SETTINGS_SUBMITTED:
                return {
                    ...state,
                    pageState: action.success
                        ? WelcomePageState.FirstCampaign
                        : state.pageState,
                    welcomeBanner: action.welcomeBanner,
                    isLoading: false
                };
            default:
                return state;
        }
    };
}
